<aside class="toolbar">
  <mat-icon
    class="toolbar-info"
    fontIcon="info_outline"
    tabindex="0"
    matTooltip="Copy selected fields, with their configuration, and paste them elsewhere in this template or other Word documents."
    matTooltipPosition="above"
  ></mat-icon>
  <button
    class="toolbar-button"
    theme="small"
    [disabled]="!copyButton.validState"
    (click)="copyButton.action()"
    (keydown.enter)="copyButton.action()"
    (keydown.space)="copyButton.action()"
  >
    <div
      class="tooltip"
      [ngClass]="{
        visible: copyButton.tooltipVisible,
        hidden: !copyButton.tooltipVisible,
      }"
    >
      <span class="tooltiptext"><mat-icon fontIcon="check"></mat-icon>Copied</span>
    </div>
    <mat-icon fontIcon="content_copy"></mat-icon>
    <span class="toolbar-button-label">Copy</span>
  </button>
  <button
    class="toolbar-button"
    theme="small"
    [disabled]="!pasteButton.validState"
    (click)="pasteButton.action()"
    (keydown.enter)="pasteButton.action()"
    (keydown.space)="pasteButton.action()"
  >
    <div
      class="tooltip"
      [ngClass]="{
        visible: pasteButton.tooltipVisible,
        hidden: !pasteButton.tooltipVisible,
      }"
    >
      <span class="tooltiptext"><mat-icon fontIcon="check"></mat-icon>Pasted</span>
    </div>
    <mat-icon fontIcon="content_paste"></mat-icon>
    <span class="toolbar-button-label">Paste</span>
  </button>
</aside>
